import React, { FC, ReactElement } from 'react';
import {useSelector} from 'react-redux';
import {internalizationState} from '../../../../../stores/reducers/sections';
import localeFieldResolver from '../../../../../helpers/locale-field-finder';

interface Props {
  speakers: any[];
  allowTargetBeforeStart: boolean;
  questionModalhandler: CallableFunction;
  viewParams?: any;
}

const ColumnsView: FC<Props> = ({ speakers, allowTargetBeforeStart, questionModalhandler }): ReactElement => {
  const { activeLangState } = useSelector(internalizationState);
  const localizeData = {
    askQuestion_ru: 'Задать вопрос',
    askQuestion_en: 'Ask a Question',
  };
  const localizedName = (field: string): string | string[] => localeFieldResolver(localizeData, field, activeLangState);

  return (
    <div className="speakers-columns">
      { 
        speakers &&
        speakers.length &&
        speakers.map((speaker: any, index: number) => (
          <div key={index} className="speakers-columns__item">
            <div className="speakers-columns__item__image">
              <img src={speaker.photo} alt={ localeFieldResolver(speaker, 'fullnameRu', activeLangState) } />
            </div>
            <p className="speakers-columns__item__name">
              { localeFieldResolver(speaker, 'fullnameRu', activeLangState) }
            </p>
            <p className="speakers-columns__item__description user-fs-text__sm">
              { localeFieldResolver(speaker, 'descriptionRu', activeLangState) }
            </p>
            {
              allowTargetBeforeStart &&
              <button
                className="speaker-item__question-btn c-accent"
                onClick={() => questionModalhandler(`${localeFieldResolver(speaker, 'fullnameRu', activeLangState)}:`)}
              >
                <svg className="fill-accent" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 0C3.589 0 0 3.589 0 8V15.5C0 15.776 0.224 16 0.5 16H8C12.411 16 16 12.411 16 8C16 3.589 12.411 0 8 0ZM8.5 10H4.5C4.224 10 4 9.776 4 9.5C4 9.224 4.224 9 4.5 9H8.5C8.776 9 9 9.224 9 9.5C9 9.776 8.776 10 8.5 10ZM11.5 7H4.5C4.224 7 4 6.776 4 6.5C4 6.224 4.224 6 4.5 6H11.5C11.776 6 12 6.224 12 6.5C12 6.776 11.776 7 11.5 7Z" fill="#4EAC93"/>
                </svg>
                <span>{ localizedName('askQuestion_ru') }</span>
              </button>
            }
          </div>
        ))
      }
    </div>
  )
}

export default ColumnsView;
